import { render } from "./CorePromiseSection.vue?vue&type=template&id=942fcb3e"
import script from "./CorePromiseSection.vue?vue&type=script&lang=js"
export * from "./CorePromiseSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__